/*
 * An object containing properties for a notification type
 */
var NotificationType = /** @class */ (function () {
    function NotificationType() {
    }
    /**
     * Danger notification type
     */
    NotificationType.DANGER = 'danger';
    /**
     * Information notification type
     */
    NotificationType.INFO = 'info';
    /**
     * Success notification type
     */
    NotificationType.SUCCESS = 'success';
    /**
     * Warning notification type
     */
    NotificationType.WARNING = 'warning';
    return NotificationType;
}());
export { NotificationType };
//# sourceMappingURL=notification-type.js.map